import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { IUserRole } from 'src/app/authentication/models/user';
import { UserService } from 'src/app/authentication/services/user.service';
import { IEmployee } from '../../employee';
import { combineLatest, filter, map, switchMap, take, tap } from 'rxjs';
import { EmployeeStore } from 'src/app/stores/component/employee.store';

@Component({
    selector: 'app-employee-role',
    templateUrl: './employee-role.component.html',
    styleUrls: ['./employee-role.component.css'],
    standalone: false
})
export class EmployeeRoleComponent implements OnInit {

  constructor(
    private userService: UserService,
    private fb: UntypedFormBuilder,
    private employeeStore: EmployeeStore
    ) { }

  form:  UntypedFormGroup;

  get userRolesArray() : UntypedFormArray {
    return this.form.get("userRoles") as UntypedFormArray
  }

  vm$ = combineLatest([
    this.employeeStore.employee$,
    this.employeeStore.employee$.pipe(
      filter(employee => !!employee),
      switchMap(employee => this.userService.getPermissionRoleDetails(employee.userId)),
      tap(userRoles => this.initForm(userRoles)),
      take(1)
    ),
  ]).pipe(
    map(([
      employee,
      userRoles
    ]) => ({
      employee,
      userRoles
    }))
  );

  ngOnInit(): void {
    this.form = this.fb.group({
      userRoles: this.fb.array([])
    })
  }


  initForm(userRoles){
    userRoles.forEach(userRole => {
      this.userRolesArray.push(this.fb.group({
        roleId: userRole.roleId,
        roleName: userRole.roleName,
        description: userRole.description,
        enabled: userRole.enabled,
      }))
    })
  }

  onSubmit(employee : IEmployee){
    this.userService.updateUsersPermissionRole(employee.userId, this.form.value)
    .subscribe(response => {
      this.form.markAsPristine();
    })
  }

}
